<template>
  <v-card class="video-section">
      <div id="video-container">
        <vue-plyr>
          <div class="plyr__video-embed">
            <iframe
              :src="videoLink"
              allowfullscreen
              allowtransparency
              allow="autoplay; muted"
            ></iframe>
          </div>
        </vue-plyr>
      </div>
      <v-expansion-panels v-if="transcript" class="transcript">
        <v-expansion-panel>
          <v-expansion-panel-header>
              Transcript
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ transcript }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
    name: 'videoPlayer',
    props:{
        videoLink: String,
        transcript: String
    },
    computed: {
      isMobile() {
        return screen.width <= 760;
      }
    }
}
</script>

<style scoped>
.video-section {
    position: sticky;
    top: 20px;
    background-color:#F5F5F5 !important;
    padding: 1rem;
}

#video-container .plyr {
  height: inherit;
}

.transcript {
    background-color: #ffffff;
    margin-top: 10px;
    max-height: 50vh;
    overflow: hidden;
    overflow-y: scroll;
    text-align: left;
}
</style>